import { createEffect } from 'effector';
import { api } from 'src/shared/api/api';
import { IPostSecondStageVotes } from '../../../model/types';

export const postSecondStageVotesFx = createEffect<IPostSecondStageVotes, void, Error>(api.postSecondStageVotes);
